var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item nav-dropdown",class:{
    open: _vm.isOpen,
    'nav-dropdown-active': _vm.hasActiveChild,
    'nav-dropdown-has-icon': _vm.hasIcon,
    'nav-dropdown-no-icon': !_vm.hasIcon,
  }},[_c('button',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"type":"button","aria-expanded":String(_vm.isOpen),"aria-haspopup":"true"},on:{"click":_vm.toggleDropdown}},[(_vm.hasIcon)?_c('i',{staticClass:"dropdown-nav-icon",class:_vm.classIcon}):_vm._e(),_c('span',{staticClass:"dropdown-nav-label"},[_vm._v(_vm._s(_vm.displayLabel))]),_c('img',{staticClass:"dropdown-chevron",attrs:{"src":_vm.dropdownIndicatorSrc,"alt":"","aria-hidden":"true"}})]),_c('ul',{staticClass:"nav-dropdown-items nav-dropdown-bg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }